import React, { useState } from "react";
import classes from "./ResetPassword.module.css";
import logo from "../../assets/images/LightLogo.webp";
import type { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../redux/actions/passwordActions";
import { Button, Form, Input, message } from "antd";
import { useLocation } from "react-router-dom";

const ResetPassword: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [resetForm, setResetForm] = useState(true);

  const onSubmit = (values: {
    newPassword: string;
    confirmNewPassword: string;
  }) => {
    const token = new URLSearchParams(location.search).get("token");

    if (!token) {
      message.error("Token nuk është i vlefshëm!");
      return;
    }

    setButtonDisabled(true);
    const payload = {
      newPassword: values.newPassword,
      confirmNewPassword: values.confirmNewPassword,
    };
    dispatch(resetPassword(payload, token)).then(() => {
      setResetForm(false);
      setButtonDisabled(false);
    });
  };

  const passwordChangeHandler = () => {
    setButtonDisabled(false);
  };

  return (
    <div className={classes.logIn}>
      <img className={classes.logInLogo} src={logo} alt="logo" />
      {resetForm ? (
        <Form
          form={form}
          name="resetPassword"
          onFinish={onSubmit}
          scrollToFirstError
        >
          <Form.Item
            name="newPassword"
            className={classes.styledInput}
            style={{ width: "100%" }}
            rules={[
              {
                required: true,
                message: "Ju lutem vendosni fjalëkalimin e ri!",
              },
              {
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/,
                message:
                  "Fjalëkalimi duhet të ketë të paktën 8 karaktere, një shkronjë të madhe, një numër dhe një simbol",
              },
            ]}
          >
            <Input.Password
              placeholder="Fjalëkalimi i ri"
              onChange={passwordChangeHandler}
            />
          </Form.Item>
          <Form.Item
            name="confirmNewPassword"
            className={classes.styledInput}
            style={{ width: "100%" }}
            rules={[
              {
                required: true,
                message: "Ju lutem konfirmoni fjalëkalimin!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Fjalëkalimet nuk përputhen!"),
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Konfirmo fjalëkalimin e ri"
              onChange={passwordChangeHandler}
            />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            style={{ width: "100%", maxWidth: "400px" }}
          >
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              disabled={buttonDisabled}
            >
              Rivendos fjalëkalimin
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <div>
          <h2>
            Fjalëkalimi juaj u rivendos me sukses, ju lutem mbyllni këtë
            dritare!
          </h2>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
